<template>
  <div class="px-3 pb-2">
    <UiButton full-width class="justify-start! gap-3!" icon="fal fa-paper-plane" icon-hover="pop" @click="emit('apri')">
      <span class="flex-1 text-left">{{ t("layout.menu.comandi_attivi") }}</span>
      <span v-if="inAttesa > 0" class="inline-flex min-w-5 items-center justify-center rounded-full bg-on-accent px-1.5 py-0.5 text-[11px] leading-none font-semibold text-accent" data-test="comandi-conteggio">
        {{ inAttesa }}
        <span class="sr-only">{{ t("layout.menu.comandi_in_attesa", { n: inAttesa }, inAttesa) }}</span>
      </span>
    </UiButton>
  </div>
</template>

<script setup lang="ts">
// Accesso ai comandi manuali ancora in corso: pulsante a tutta larghezza con il numero di quelli in attesa (annunciato anche agli
// screen reader). La logica sta nello store `comandiAttivi` e nel pannello; qui si mostra e si emette `apri`.
import { useI18n } from "vue-i18n";

defineProps<{ inAttesa: number }>();
const emit = defineEmits<{ apri: [] }>();
const { t } = useI18n();
</script>
